import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';

import { OfflineSuppAndOfflineOfficeProperties, OfflineSupplierProperties } from '../Models/OfflineSupplierProperties';
import { environment } from '../../environments/environment';
import { PassengerCreationResponse } from '../Models/BookingPassengerTicketIssuanceProperties';

@Injectable({
  providedIn: 'root'
})
export class OfflinesuppliersService {
  baseUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  getOfflineSupplier(): Observable<OfflineSupplierProperties[]> {
    return this.http.get<OfflineSupplierProperties[]>(this.baseUrl + '/OfflineSupplier/GetOfflineSupplier')
      .pipe(map((data: OfflineSupplierProperties[]) => { return data; }), catchError(error => { return throwError(error); }))
  }

  GetOfflineSupplierByID(offlineSupplierId): Observable<OfflineSupplierProperties> {
    return this.http.get<OfflineSupplierProperties>(this.baseUrl + '/OfflineSupplier/GetOfflineSupplierByID/'+ offlineSupplierId).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }


  CreateOfflineSupplier(newobj): Observable<PassengerCreationResponse> {
    console.log(newobj);
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/OfflineSupplier/CreateOfflineSup', newobj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  UpdateOfflineSupplier(Obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/OfflineSupplier/UpdateOfflineSupplier', Obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateStatus(offlineSupplierId, isActive): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/OfflineSupplier/UpdateStatusBtn/' + offlineSupplierId + "/" + isActive, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
}
